import UploadVideoField from './UploadVideoField'

export default UploadVideoField
